/**
 * @module store/promos/getters
 *
 * @version 1.0.0
 * @copyright SBC 2021
 */


/**
 * Getter: Возвращает массив всех акций
 *
 * @returns {array}
 */
const promos = state => state.promos;


/**
 * Getter: Возвращает массив действующийх на текущий момент акций
 *
 * @returns {array}
 */
const activePromos = state => {
  const now = new Date();

  return state.promos.filter(item => (!item.endDate || (new Date(item.endDate) >= now)));
}


/**
 * Getter: Возвращает флаг загружаются ли точки в текущий момент
 *
 * @returns {boolean}
 */
const isPromosLoading = state => state.isPromosLoading;

export default {
  activePromos,
  isPromosLoading,
  promos,
};
